module.exports = __webpack_public_path__ + "static/media/Whatsapp-01.8f5e1467.svg";